var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactFormLineVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 330,
    viewBox: "0 0 1 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0L0.500014 330",
    stroke: "#40585A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFormLineVertical);
export default __webpack_public_path__ + "static/media/contact-form-line-vertical.045ad3769dd9ac5a6a1b9744e4de0be2.svg";
export { ForwardRef as ReactComponent };